<template>
  <div class="benefit-item-sales">
    <div class="iconwrap">
      <img class="icon" :src="iconSource" alt="">
    </div>
    <h3 class="title" v-html="title.replace('\n', '<br>')"></h3>
    <p class="text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    text: String,
    icon: String,
  },
  computed: {
    iconSource() {
      // eslint-disable-next-line import/no-dynamic-require
      return require(`@/assets/new-icons/${this.icon}.svg`);
    },
  },
};
</script>

<style lang="scss" scoped>
.benefit-item-sales {
  color: #4B4B4B;
  margin-bottom: 80px;

  .iconwrap {
    position: relative;
    width: 100px;
    height: 100px;
    background-color: white;
    box-shadow: 0px 6px 30px #0000002B;
    margin-bottom: 30px;
    display: flex;
    align-self: center;
    justify-content: center;
    .icon {
      transition: transform .3s;
      transform: scale(0.85);
    }
    &::before {
      content: "";
      position: absolute;
      z-index: -1;
      left: 16px;
      top: -16px;
      width: 100%;
      height: 100%;
      border: 3px solid $primary;
      transition: .3s all;
    }
    &:hover::before {
      left: 8px;
      top: -8px;
    }
    &:hover .icon {
      transform: scale(1.1);
    }
    @media screen and (min-width: $screen-md) {
      width: 125px;
      height: 125px;
    }
  }
  .title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
    @media screen and (min-width: $screen-md) {
      font-size: 24px;
    }
  }
  .text {
    font-size: 15px;
  }
}
</style>
